import React, { useContext } from 'react'
import { MainContext } from '../../context/Main.context';
import { LicenceTypes } from '../../utils/LicenceTypes';
import { Ellispis } from '../MorphoTab/MorphoTab.styled';
import { Tab } from '../Tab/Tab';
import { DocumentDownloadLink, DocumentFileDisplay, DocumentFileInput, DocumentFileLabel, DocumentFileName, DocumentsInputWrapper } from './DocumentsTab.styled';

export const DocumentsTab = () => {
    const { 
        currentFormTab,
        files,
        licenceType,
        register,
        setFiles,
    } = useContext(MainContext);

    return (
        <Tab show={currentFormTab === 6}>
            <h2>Documents</h2>
            <Ellispis>Si ce n'est pas déjà fait, vous pouvez télécharger les documents nécessaires via le bouton <i>télécharger</i></Ellispis>
            <DocumentsInputWrapper>
                <h4>Autorisation et engagements</h4>
                <DocumentDownloadLink
                    href={licenceType === LicenceTypes.YOUNG ? require("../../assets/files/Autorisations-engagements-mineurs.pdf") : require("../../assets/files/Autorisations-engagements-majeurs.pdf")} 
                    target={"_blank"}
                    download
                    rel="noreferrer"
                >
                    Télécharger le document
                </DocumentDownloadLink>
                <DocumentFileInput
                    type="file"
                    accept="pdf, jpg, jpeg, png"
                    id="autorization-engagements"
                    name="autorization-engagements"
                    {...register("autorization-engagements", {
                        required: {
                            value: false,
                        },
                        onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
                            if(event.target.files) {
                                setFiles({
                                    ...files,
                                    autorizationFile: event.target.files[0],
                                })
                            }
                        }
                    })}
                />
                <DocumentFileDisplay>
                    <DocumentFileName>
                        {files.autorizationFile ? files.autorizationFile.name : ""}
                    </DocumentFileName>
                    <DocumentFileLabel htmlFor="autorization-engagements">
                        Choisir un fichier
                    </DocumentFileLabel>
                </DocumentFileDisplay>
                <Ellispis>Fichiers acceptés : pdf, jpg, jpeg, png</Ellispis>
            </DocumentsInputWrapper>
            {/* <h4>Document médical</h4>
            <Ellispis>
                Si vous avez fournis un certificat médical avant le 01/06/2020, vous êtes éligibles au questionnaire de santé
            </Ellispis>
            <ButtonChoiceWrapper>
                <ButtonChoice
                    isActive={certif}
                    type="button"
                    onClick={() => setCertif(true)}
                >
                    Certificat Médical
                </ButtonChoice>
                <ButtonChoice
                    isActive={!certif}
                    type="button"
                    onClick={() => setCertif(false)}
                >
                    Questionnaire de santé
                </ButtonChoice>
            </ButtonChoiceWrapper>
            <DocumentsInputWrapper>
                <h4>{certif ? "Certificat médical FFHB" : "Questionnaire de santé FFHB"}</h4>
                <DocumentDownloadLink
                    href={
                        certif ?
                            "https://res.cloudinary.com/ffhb-production/image/upload/v1654766262/ffhb-prod/assets/2022-23_certificat_medical.pdf"
                        : licenceType === LicenceTypes.YOUNG ?
                            "https://res.cloudinary.com/ffhb-production/image/upload/v1654766262/ffhb-prod/assets/2022-23_Questionnaire_sante_MINEUR.pdf"
                            : "https://res.cloudinary.com/ffhb-production/image/upload/v1654766262/ffhb-prod/assets/2022-23_attestation_questionnaire_sante.pdf"
                    } 
                    target={"_blank"}
                    download
                    rel="noreferrer"
                >
                    Télécharger le document
                </DocumentDownloadLink>
                <DocumentFileInput
                    type="file"
                    accept="pdf, jpg, jpeg, png"
                    id="medical-documents"
                    name="medical-documents"
                    {...register("medical-documents", {
                        required: {
                            value: true,
                            message: "Veuillez fournir un document médical (questionnaire ou certificat médical)",
                        },
                        onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
                            if(event.target.files) {
                                setFiles({
                                    ...files,
                                    certif: certif ? event.target.files[0] : null,
                                    healthForm: !certif ? event.target.files[0] : null,
                                })
                            }
                        }
                    })}
                />
                <DocumentFileDisplay>
                    <DocumentFileName>
                        {certif ? files.certif ? files.certif.name : "" : files.healthForm ? files.healthForm.name : ""}
                    </DocumentFileName>
                    <DocumentFileLabel htmlFor="medical-documents">
                        Choisir un fichier
                    </DocumentFileLabel>
                </DocumentFileDisplay>
                <Ellispis>Fichiers acceptés : pdf, jpg, jpeg, png</Ellispis>
                <ErrorMessage message={errors["medical-documents"] && errors["medical-documents"].message} />
            </DocumentsInputWrapper> */}
        </Tab>
    )
}
